import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { AppleIcon, SmartphoneIcon } from 'lucide-react';
import { PhoneMockup } from './PhoneMockup';
export function Hero() {
  return <section className="relative min-h-screen pt-40 pb-20 px-6 overflow-hidden bg-[#FBF3EA]" data-id="element-70">
      {/* Decorative elements */}
      <div className="absolute top-20 left-10 w-96 h-96 bg-[#FFE4E4] rounded-full blur-3xl opacity-60" data-id="element-71"></div>
      <div className="absolute bottom-20 right-10 w-[500px] h-[500px] bg-[#E8E0F5] rounded-full blur-3xl opacity-60" data-id="element-72"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-[#FCEFE3] rounded-full blur-3xl opacity-80" data-id="element-73"></div>

      {/* Sparkle decorations */}
      <div className="absolute top-40 left-1/4 text-[#FFB6B6] text-4xl opacity-80" data-id="element-74">
        ✦
      </div>
      <div className="absolute bottom-40 right-1/4 text-[#D1C4E9] text-5xl opacity-80" data-id="element-75">
        ✦
      </div>

      <div className="relative max-w-7xl mx-auto" data-id="element-76">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-77">
          {/* Text content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left" data-id="element-78">
            <h1 className="text-6xl md:text-7xl lg:text-[80px] leading-[1.05] font-black text-[#15193D] mb-8 tracking-tight" style={{
            fontFamily: 'Fraunces, serif'
          }} data-id="element-79">
              Your family, perfectly in sync
            </h1>

            <p className="text-xl md:text-2xl text-[#15193D]/80 mb-12 max-w-xl mx-auto lg:mx-0 font-medium leading-relaxed" data-id="element-80">
              Keep everyone connected with shared calendars, to-dos, memories,
              and instant updates — all in one beautiful app.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-81">
              <button className="bg-[#15193D] text-[#FBF3EA] px-8 py-4 rounded-2xl font-semibold hover:bg-[#15193D]/90 transition-all hover:scale-105 flex items-center justify-center gap-3 shadow-xl" data-id="element-82">
                <AppleIcon className="w-7 h-7" data-id="element-83" />
                <div className="text-left" data-id="element-84">
                  <div className="text-xs opacity-80 font-medium" data-id="element-85">
                    Download on the
                  </div>
                  <div className="text-lg font-bold" data-id="element-86">App Store</div>
                </div>
              </button>

              <div className="bg-white/50 border-2 border-[#15193D]/10 text-[#15193D]/50 px-8 py-4 rounded-2xl flex items-center justify-center gap-3 cursor-default backdrop-blur-sm" data-id="element-87">
                <SmartphoneIcon className="w-7 h-7" data-id="element-88" />
                <div className="text-left" data-id="element-89">
                  <div className="text-xs opacity-80 font-medium" data-id="element-90">
                    Google Play
                  </div>
                  <div className="text-lg font-bold" data-id="element-91">Coming Soon</div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Hero phone mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-92">
            <PhoneMockup imageUrl="https://cdn.magicpatterns.com/uploads/qr2MJTGogQDmwwVTue274Q/0x0ss_(48).png" alt="Famday Calendar App" data-id="element-93" />
          </motion.div>
        </div>
      </div>
    </section>;
}